export default __webpack_public_path__ + "static/wunschpiercing-7-43dd1eb4654ea5bebc45fed988b550a1.jpg";